import React, { useEffect, useState } from "react";
import Dashboard_IndividualAdmin from "./Dashboard_Individual_Admin";
import { Container, Row, Col } from "reactstrap";
//ICONS
import ServidoresACARGO from "assets/icons/ServidoresACARGO.svg"
import JornadaLABORAL from "assets/icons/JornadaLABORAL.svg"
import Vacaciones from "assets/icons/Vacaciones.svg"
import PermisosLicencias from "assets/icons/permisosLICENCIAS.svg"
import RequerimientosPersonal from "assets/icons/RequerimientosPERSONAL.svg"
import GuiasSistemas from "assets/icons/GUIAsistemas.svg"
import Reglamentos from "assets/icons/Reglamentos.svg"
import Formatos from "assets/icons/FormatosREPORTES.svg"
import ResumenIngresos from "assets/icons/ResumenINGRESOS.svg"
import Cargando from "components/Varios/Cargando";

import Egresos from "assets/icons/Egresos.svg"
import Ingresos from "assets/icons/Ingresos.svg"
import Descargas from "assets/icons/Descargas.svg"


//URL
import configData from "../../../config.json";
import { authenticationService } from "services/authentication.service";
import { UserData } from "components/Sidebar/Sidebar_Principal";
//OTROS
import axios, { AxiosResponse } from "axios";

const qs = require('qs')

export type Dashboard_Admin_Type = 
{
    titulo:string;
    contenido?:string;
    color:string;
    icon?:string,
    datos?:any,
    status_response?:number,
    is_for_civil?:boolean,
    no_circle?:boolean
}

export type Vacaciones_Recientes = 
{
    fechas_vacaciones:Array<string>,
    numero_vacaciones:number
}


export type Data_Dashboard_Vacaciones = 
{
    cantidad_vacaciones_pendientes:number,
    isinVacation:Boolean,
    fecha_fin_vacaciones?:Date,
    // meses_vacaciones_planificado?:Array<string>,

    dias_planificados:number,
    dias_tomados:number,
    estado_solicitud_vacaciones:string,
    vacaciones_recientes?:Array<{key:string,value:number}>,
    anio_vacaciones_recientes:number,
    periodo_planificacion_activo:boolean,
    tiene_planificaciones_rechazadas_sgteanio:boolean,
    tiene_planificacion_sgteanio:boolean,
    cantidadMinimaFaltaPlanificar:number,
    anioPeriodoPlanificacion:number,
}

export type Data_Dashboard_Ingresos = 
{
    rmu:number,
    horas_extras:number,
    decimo_tercero:number,
    decimo_cuarto:number,
    fondo_reserva:number,
    fecha_resultados:Date
}


export const expresion_civil = (tipo_regimen:Array<number>|undefined):boolean => {
    if(!tipo_regimen) return true
    const REGIMEN_NO_CIVIL = [6,7,8,9]; 
    var valor_retorno = true
    tipo_regimen.map((value,index)=> {
        valor_retorno = !REGIMEN_NO_CIVIL.includes(value);
        })
    return valor_retorno
}

export const expresion_adm = (tipo_regimen: Array<number> | undefined): boolean => {
    if (!tipo_regimen) return true
    const REGIMEN_ADM = [6, 7, 9];
    var valor_retorno = false;
    for (var i = 0; i < tipo_regimen.length; i++) {
        valor_retorno = REGIMEN_ADM.includes(tipo_regimen[i]);
        if (valor_retorno) return valor_retorno;
    }

    return valor_retorno
}




export const  titulos_dashboard:Array<string> = ["Resumen Ingresos Mensuales","Resumen Egresos Mensuales","Resumen Ingresos Anuales a La Fecha","Vacaciones","Zona de Descargas"]

const Dashboard_Admin:React.FC = () => {

    

    var contenido_dashboard:Array<Dashboard_Admin_Type> = [
        {
            titulo: titulos_dashboard[0],
            color:"yellowgreen",
            icon:ResumenIngresos,
            is_for_civil:false,
   

        },
        {
            titulo: titulos_dashboard[1],
            color:"yellowgreen",
            icon:Egresos,
            is_for_civil:false,
            no_circle:true,
        },
        {
            titulo: titulos_dashboard[2],
            color:"yellowgreen",
            icon:Ingresos,
            is_for_civil:false,
            no_circle:true,


        },
        {
            titulo: titulos_dashboard[3],
            color:"#FFC200",
            icon:Vacaciones,
            is_for_civil:false

        },
        //{
        //    titulo: titulos_dashboard[4],
        //    icon:Descargas,
        //    no_circle:true,
        //    color:"yellowgreen",
        //},
        // {
        //     titulo: "Servidores a cargo",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"yellowgreen",
        //     icon:ServidoresACARGO
        // },
        // {
        //     titulo: "Jornada de personal",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(224, 207, 50)",
        //     icon:JornadaLABORAL  
        // },
        // {
        //     titulo: "Licencias y permisos",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(255, 130, 28)",
        //     icon:PermisosLicencias

        // },
        // {
        //     titulo: "Requerimiento de personal",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(110, 2, 124)",
        //     icon: RequerimientosPersonal

        // },
        // {
        //     titulo: "Guías de uso de sistema",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(110, 2, 124)",
        //     icon: GuiasSistemas

        // },
        // {
        //     titulo: "Reglamentos de uath",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(51, 186, 228)",
        //     icon:Reglamentos
            
        // },
        // {
        //     titulo: "Formatos",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(51, 186, 228)",
        //     icon:Formatos

        // },
        // {
        //     titulo: "Desvinculación",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(150, 51, 216)"

            
        // },
        
        // {
        //     titulo: "Registro entrada y salida",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(52, 36, 121)"

        // },
        // {
        //     titulo: "Permisos y licencias",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"rgb(46, 125, 190)"

        // },
        
        // {
        //     titulo: "Plan retorno",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"red"

        // },
        // {
        //     titulo: "Reportes",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //     color:"red"

        // },
        // {
        //     titulo: "Solicitudes",
        //     contenido: "LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM LOREM IPSUM",
        //      color:"red"

        // }
        

    ]

    const [loading, setloading] = useState<boolean>(true)
    // const [dataVacaciones, setdataVacaciones] = useState<Data_Dashboard_Vacaciones>();
    const [arrayContenidoDashboard, setarrayContenidoDashboard] = useState<Array<Dashboard_Admin_Type>>(contenido_dashboard);
    const [currentUser, setcurrentUser] = useState<UserData|null>(null);

    const function_validar_request = (error:any):number => {
        if(error.response){
            return error.response.status
        }
        return 0;
    }

    const Obtener_Informacion_Dashboard = async () => {

        var informacion_usuario = authenticationService.currentUserValue;
        setcurrentUser(informacion_usuario);
        var regimen:Array<number> = informacion_usuario.regimen_usuario;
        var newArrayContenidoDashboard = contenido_dashboard;
        try {
            const respuesta_ingresos = await axios.get(configData.SERVER_URL + `DatosDashboard/Ingresos/${informacion_usuario.idpersona}`,
            {   params:{lista_regimen:regimen},
                paramsSerializer:
                    params => {
                        return qs.stringify(params)
                },
                headers:{
                    Authorization:`KEYESPOL ${informacion_usuario.token}`
                }
            });
            
            newArrayContenidoDashboard[0].datos = respuesta_ingresos.data;
        } catch (error) {
            newArrayContenidoDashboard[0].status_response = function_validar_request(error)
        }

        try {
            const respuesta_egresos = await axios.get(configData.SERVER_URL + `DatosDashboard/Egresos/${informacion_usuario.idpersona}`,{
                headers:{
                    Authorization:`KEYESPOL ${informacion_usuario.token}`
                }
            });
            
            newArrayContenidoDashboard[1].datos = respuesta_egresos.data;
        } catch (error) {
            newArrayContenidoDashboard[1].status_response = function_validar_request(error)
        }

        try {
            const respuesta_egresos = await axios.get(configData.SERVER_URL + `DatosDashboard/IngresosAnuales/${informacion_usuario.idpersona}`,{
                headers:{
                    Authorization:`KEYESPOL ${informacion_usuario.token}`
                }
            });
            
            newArrayContenidoDashboard[2].status_response = respuesta_egresos.status
            newArrayContenidoDashboard[2].datos = respuesta_egresos.data;
           

        } catch (error) {
            newArrayContenidoDashboard[2].status_response = function_validar_request(error)
        }



        try {
            const respuesta_vacaciones = await axios.get(configData.SERVER_URL + `DatosDashboard/Vacaciones/${informacion_usuario.idpersona}`,
            {
                headers:{
                    Authorization:`KEYESPOL ${informacion_usuario.token}`
                }
            });
            var datos_vacaciones:Data_Dashboard_Vacaciones = respuesta_vacaciones.data;
            datos_vacaciones.periodo_planificacion_activo = informacion_usuario.periodo_planificacion_vac_activo;
            newArrayContenidoDashboard[3].datos = respuesta_vacaciones.data;
        } catch (error) {
            newArrayContenidoDashboard[3].status_response = function_validar_request(error);

        }
        
        //try {
        //    const respuesta_formulario = await axios.get(configData.SERVER_URL + `DatosDashboard/Descargas/${informacion_usuario.idpersona}`,{
        //        headers:{
        //            Authorization:`KEYESPOL ${informacion_usuario.token}`
        //        }
        //    });
            
        //    newArrayContenidoDashboard[4].datos = respuesta_formulario.data;
        //} catch (error) {
        //    newArrayContenidoDashboard[4].status_response = function_validar_request(error)
        //}

        //CALCULOS PARA DIFERENCIA DE INGRESOS Y EGRESOS
        try{
            var datos_con_valor_liquido = newArrayContenidoDashboard[0].datos;

            datos_con_valor_liquido["egresos"] = newArrayContenidoDashboard[1].datos;

            newArrayContenidoDashboard[0].datos = datos_con_valor_liquido;
        }
        catch (error) {
            
        }
        

        setarrayContenidoDashboard(newArrayContenidoDashboard);
        setloading(false);
    }

  

    useEffect(() => {
        //Obtener_Informacion_Dashboard();
        setloading(false);
    }, [])
    if(loading) {
        return(
            <div className="content">
                <Cargando/>
            </div>
        )
    }
    else if(arrayContenidoDashboard) {
        return(
            <React.Fragment>
                <div className="content">
                    <div className="parent_dashboards_admin">
                    <Container fluid={true}>
                        {/*<Row>*/}
                        {/*    {*/}
                        {/*        arrayContenidoDashboard.map((dash,index)=>{*/}
                        {/*            if(!dash.is_for_civil && !expresion_civil(currentUser?.regimen_usuario)){*/}
                        {/*                return(*/}
                        {/*                    <Col className="mb-5" xl={4} lg={6} md={6}  key={index}>*/}
                        {/*                        <Dashboard_IndividualAdmin no_circle={dash.no_circle} status_response={dash.status_response?dash.status_response:0} titulo={dash.titulo}  contenido ={dash.contenido} color={dash.color} icon={dash.icon?dash.icon:""} datos={dash.datos?dash.datos:""} />*/}
    
                        {/*                    </Col>*/}
                        {/*                )*/}
                        {/*            }*/}
                        {/*            else if(dash.is_for_civil == undefined ){*/}
                        {/*                return(*/}
                        {/*                    <Col className="mb-5" xl={4} lg={6} md={6}  key={index}>*/}
                        {/*                        <Dashboard_IndividualAdmin no_circle={dash.no_circle} status_response={dash.status_response?dash.status_response:0} titulo={dash.titulo}  contenido ={dash.contenido} color={dash.color} icon={dash.icon?dash.icon:""} datos={dash.datos?dash.datos:""} />*/}
    
                        {/*                    </Col>*/}
                        {/*                )*/}
                        {/*            }*/}
                                    
                        {/*        })*/}
                        {/*    }*/}
                            
                        {/*</Row>*/}
                    </Container>
                    </div>
                </div>
                
            </React.Fragment>
        )
    }
    else {
        return (
            <div className="content">
                Ha ocurrido un inconveniente intente más tarde
            </div>
        )
        
    }
}
export default Dashboard_Admin;
